<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import './assets/svg/trash.svg';

import config from './config';
import { getAccessToken, getDataFromAccessToken } from './utils/tokens';
import { fetchAuth } from './api/odin-api';
import { SET_ADMIN_DATA } from './constants';
import store from './store';

const { cookieName } = config;

export default {
  name: 'App',

  async beforeCreate() {
    sessionStorage.setItem('redirect', window.location.pathname);

    const accessToken = getAccessToken(cookieName);
    if (!accessToken && this.$route.name !== 'Auth') return this.$router.push({ name: 'Auth' });

    const decoded = getDataFromAccessToken(config.cookieName);
    const { integer_id: integerId } = decoded['bb-auth:meta'];
    const response = await fetchAuth.get(`/api/v1/users/${integerId}`);
    const user = response.data.data;
    store.commit(SET_ADMIN_DATA, { user });

    return null;
  },
};
</script>
<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,600&subset=cyrillic');
    @import "./assets/scss/transitions";

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: 'Roboto', sans-serif !important;
        background-color: #eeeeee;
    }

    img {
        max-width: 100%;
    }

    .pointer {
        cursor: pointer;
    }

    .hover-opacity {
        transition: opacity 300ms;
        opacity: 0.8;
        &:hover {
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue